import React from "react"
import { Box, Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

const useStyle = makeStyles(theme => ({
  fullWidth: { width: "100%" }, // flexboxの子要素を横幅目いっぱいにする
  campaignThanksBox: {
    margin: "auto", // 中央寄せ
    width: "100%",
    maxWidth: "345px",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "600px",
    },
    padding: "5px 10px",
    textAlign: "center",
    backgroundColor: "#FDEADA",
    border: "1px solid #CC0033",
  },
  campaignThanksText: {
    fontWeight: 800,
    color: "#CC0033",
    fontSize: "16px",
  },
  campaignText: {
    color: "#333333",
    fontSize: "14px",
  },
}))

const CampaignEntryThanks = () => {
  const classes = useStyle()

  return (
    <Grid container direction="column" alignItems="center">
      <Grid item className={classes.fullWidth}>
        <Box className={classes.campaignThanksBox}>
          <Typography className={classes.campaignThanksText}>
            ご協力ありがとうございます
          </Typography>
          <Typography className={classes.campaignText}>
            お客さまはポイントプレゼント対象※です
          </Typography>
        </Box>
      </Grid>
    </Grid>
  )
}

export default CampaignEntryThanks
